import { render, staticRenderFns } from "./Startseite Membership.vue?vue&type=template&id=1a8f7244&"
import script from "./Startseite Membership.vue?vue&type=script&lang=js&"
export * from "./Startseite Membership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports